/**
 * How Teslyn writes a zFid (MB's R129, 27 Oct 2026): a whole number with no thousands separator, as Oasis montaj, the
 * QC log and the nav system's files write it ("zFid 4545650 to 4564900", never "4,545,650"). Every screen, report and
 * export that shows a zFid takes its text from here.
 */

/** A zFid as text: rounded to a whole number, no separators (`12135250`); "–" when there is none. */
export function formatZfid(fid: number | null | undefined, none = '–'): string {
  if (fid === null || fid === undefined || !Number.isFinite(fid)) return none;
  return String(Math.round(fid));
}

/** `zFid 4545650 to 4564900` (R129). */
export function zfidRangeText(from: number, to: number): string {
  return `zFid ${formatZfid(from)} to ${formatZfid(to)}`;
}

/**
 * A zFid as typed (R127: the processor types the section's ends): digits only, with spaces or commas between
 * thousands taken out ("4,545,650" and "4 545 650" are 4545650). Null when it is not a whole number.
 */
export function parseZfid(text: string): number | null {
  const t = text.trim().replace(/[\s,]/g, '');
  if (!/^\d+(\.0+)?$/.test(t)) return null;
  const v = Math.round(Number(t));
  return Number.isFinite(v) ? v : null;
}
